const state = () => ({
  requestNum: 0,
})

const mutations = {
  addRequestNum(currentState, delta = 1) {
    currentState.requestNum = Math.max(0, currentState.requestNum + delta)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
